import React, { useState, useEffect } from "react";
import { Modal, Button, Header, Icon, Dropdown, Form, Checkbox } from "semantic-ui-react";
import {
  CancellationReason,
  IOrderInfo,
  IRxSortBoxInfo,
} from "../../../lib/rxAutoMessages/rxAutoMessages";
import "./cancellationModal.css";

export const CancellationModal = ({
  open,
  onClose,
  loopTeamleader,
  orderInfo,
}: {
  open: boolean;
  onClose: (cancel: boolean, reason: CancellationReason, comment: string, bags: number[]) => void;
  loopTeamleader: boolean;
  orderInfo: IOrderInfo | null;
}) => {
  const [comment, setComment] = useState<string | number | undefined>("");
  const [reason, setReason] = useState(loopTeamleader ? CancellationReason.BoxRedirectToCheckstationCancelDelivery : CancellationReason.BoxRedirectToSupervisor);
  const [rxBagsToBeCancelled, setRxBagsToBeCancelled] = useState<number[]>([]);
  const [cancelAll, setCancelAll] = useState<boolean>(true);

  const choices = [
    CancellationReason.BoxRedirectToSupervisor,
    //CancellationReason.BoxRedirectToCheckstationCancelOrder,
    CancellationReason.BoxRedirectToCheckstationCancelDelivery,
    // CancellationReason.BoxRedirectToCheckstation,
  ];

  useEffect(() => {
    if (reason !== CancellationReason.BoxRedirectToCheckstationCancelOrderPartially || cancelAll) {
      setRxBagsToBeCancelled([]);
    }
  }, [reason, cancelAll]);

  const handleConfirm = async () => {
    if (reason === CancellationReason.BoxRedirectToCheckstationCancelOrder && !cancelAll) {
      onClose(true, CancellationReason.BoxRedirectToCheckstationCancelOrderPartially, comment as string, rxBagsToBeCancelled);
    } else {
      onClose(true, reason, comment as string, []);
    }
  };

  const getCancellationReasonText = (reason: CancellationReason) => {
    switch (reason) {
      case CancellationReason.BoxRedirectToCheckstation :
        return "Skicka order till kontrollstation";
      case CancellationReason.BoxRedirectToSupervisor:
        return "Skicka order till ansvarig station";
      case CancellationReason.BoxRedirectToCheckstationCancelOrder:
        return "Stryk order";
      case CancellationReason.BoxRedirectToCheckstationCancelDelivery:
        return "Avbryt utleverans";
    }
  };

  const getOptions = () => {
    return choices
      .filter((reason) => filterOptions(reason))
      .map((reason) => {
        return {
          text: getCancellationReasonText(reason),
          value: reason,
        };
      });
  };

  const filterOptions = (reason: CancellationReason) => {
    if (!loopTeamleader && reason === CancellationReason.BoxRedirectToSupervisor) {
      return reason;
    } else if (loopTeamleader && reason !== CancellationReason.BoxRedirectToSupervisor) {
      return reason;
    }
  };

  const getBagOptions = () => {
    const options = orderInfo?.SortBoxes.filter((bag) => filterBagOptions(bag)).map((bag) => {
      return {
        text: bag.RxBagID,
        value: bag.SortBoxID,
      };
    });
    return options;
  };

  const filterBagOptions = (bag: IRxSortBoxInfo) => {
    if (!bag.Done) {
      return bag;
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => onClose(false, CancellationReason.undefined, "", [])}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Header>
        <div className="cancellationHeaderContainer">
          <div className="cancellationHeader">
            <Icon size="big" name="warning sign" color="red"></Icon>
            Avbryt order
          </div>
        </div>
      </Header>
      <Modal.Content>
          <div className="flexRow flexStart">
            <Dropdown
              className="cancellationDropdown"
              selection
              placeholder="Välj anledning"
              onChange={(_, data) => setReason(data.value as CancellationReason)}
              options={getOptions()}
              value={reason}
            ></Dropdown>
            <div className="flexColumn spaceBetween bagSelectionContainer">
              {reason === CancellationReason.BoxRedirectToCheckstationCancelOrder && !cancelAll ? (
                <Dropdown
                  className="bagDropdown"
                  placeholder="påsar som ska strykas"
                  multiple
                  fluid
                  selection
                  onChange={(_, data) => setRxBagsToBeCancelled(data.value as number[])}
                  options={getBagOptions()}
                ></Dropdown>
              ) : null}
              {reason === CancellationReason.BoxRedirectToCheckstationCancelOrder ? (
                <Checkbox
                  onChange={(_, data) => setCancelAll(data.checked as boolean)}
                  label="stryk allt"
                  className="cancelOrderCheckbox"
                  toggle
                  checked={cancelAll}
                ></Checkbox>
              ) : null}
            </div>
          </div>
        <Form className="cancellationForm">
          <Form.TextArea
            required
            label="Kommentar"
            value={comment}
            rows={8}
            onChange={(_, data) => setComment(data.value)}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={() => onClose(false, CancellationReason.undefined, "", [])}>
          AVBRYT
        </Button>
        <Button
          disabled={
            comment === "" ||
            !/\S/.test(comment as string) ||
            reason === CancellationReason.undefined ||
            reason === CancellationReason.BoxRedirectToCheckstationCancelOrder && !cancelAll && rxBagsToBeCancelled.length === 0
          }
          color="green"
          onClick={() => handleConfirm()}
        >
          OKEJ
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
